<template>
    <div class="collectOrderManagement">
        <div>
            <div class="orderSearchBox">
                <div class="timeSearch">
                    <span style="color: #b2b2b2;">区间筛选</span>
                    <el-date-picker
                        v-model="createDateValue"
                        @change="chooseDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="—"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </div>
                <div class="searchItem">
                    <!--<el-input v-model="form.activityName" placeholder="活动名称"></el-input>-->
                    <el-select clearable
                               v-model="activityUuid" placeholder="活动名称">
                        <el-option
                            v-for="item in activityList"
                            :key="item.uuid"
                            :label="item.activityName"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </div>
                <el-input v-model="goodsName" placeholder="商品名称"></el-input>
                <el-input v-model="storeName" placeholder="商家名称"></el-input>
                <el-input v-model="buyerName" placeholder="买家名称"></el-input>
                <el-input v-model="orderNo" placeholder="订单编号"></el-input>
                <el-button class="searchBtn" @click="searchInfo">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="resetData">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
            <div class="orderListTable">
                <ul class="tableHeader">
                    <li class="name">商品信息</li>
                    <li class="price">商品价格</li>
                    <li class="activeName">活动名称</li>
                    <li class="num">数量</li>
                    <li class="payment">总价格</li>
                    <li class="status">订单状态</li>
                </ul>
                <ul class="tableBody" v-if="printMessage.length != 0" v-loading="loading">
                    <li
                        class="bodyItem"
                        v-for="(printItems, index) in printMessage"
                        :key="index"
                    >
                        <div class="itemTop">
                            <div>创建时间：{{ printItems.orderBase.createDate }}</div>
                            <div>订单编号：{{ printItems.orderBase.orderNo }}</div>
                            <div class="merchantInfo">
                                <!-- <img :src="printItems.logo" alt=""/> -->
                                <div class="merchantInfo">
                                    <span>商家：</span>
                                    <span>{{ printItems.storeName }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="itemBottom">
                            <div class="name">
                                <div
                                    class="orderInfo"
                                    v-for="(modelItems, modelIndex) in printItems.shopList"
                                    :key="modelIndex"
                                >
                                    <img :src="modelItems.specUrl" alt=""/>
                                    <div class="infoContent">
                                        <div class="infoName">{{ modelItems.goodsName }}-{{ modelItems.specName }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="price">
                                <div
                                    v-for="(modelItems, modelIndex) in printItems.shopList"
                                    :key="modelIndex"
                                    style="padding: 50px;"
                                >
                                    <p style="text-decoration: line-through">¥{{ modelItems.goodsPrice }}</p>
                                    <p style="color:red">¥{{ modelItems.price }}</p>
                                </div>
                            </div>
                            <div class="activeName">
                                <div>
                                    {{ printItems.orderBase.activityName }}
                                </div>
                            </div>
                            <div class="num">
                                <div
                                    v-for="(modelItems, modelIndex) in printItems.shopList"
                                    :key="modelIndex"
                                    style="padding: 50px;"
                                    :class="printItems.shopList.length > 1 ? 'numborder' : ''"
                                >
                                    {{ modelItems.num }}
                                </div>
                            </div>
                            <div class="payment">
                                <h3>¥{{ printItems.orderBase.totalPrice }}</h3>
                                <div class="title">(含运费：{{ printItems.orderBase.transportationPrice==null?0:printItems.orderBase.transportationPrice }}元)</div>
                            </div>
                            <div class="status">
                                <div class="statusName">{{ printItems.orderBase.orderStatusCn }}</div>
                                <el-button type="text" class="operationBtn" @click="goToDetail(printItems.orderBase.uuid)">订单详情
                                </el-button>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="orderNomesaage" v-loading="loading" v-else>暂无数据</div>
            </div>
        </div>
        <el-pagination
            v-if="printMessage.length != 0"
            background
            @current-change="handleCurrentChange"
            @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange"
            layout="total,prev, pager, next,jumper"
            :page-size="pageSize"
            :total="total"
            class="pagination"
        >
        </el-pagination>
    </div>
</template>

<script>
    import {
        getOrderShopList,
        getDictionaryItem,
        activitiesList,
    } from "../../utils/interface";
export default {
    name: "collectOrderManagement",
    components: {},
    data() {
        return {
            loading: false,
            orderStatus: "ALL",
            createDateValue: null,
            startTime:"",
            endTime:"",
            goodsName: "",
            storeName: "",
            orderNo: "",
            buyerName: "",
            orderStatusValue: "",
            evaluateStatusValue: "",
            postSalesServiceValue: "",
            //分页
            current: 1,
            total: 0,
            pageSize: 10,
            printMessage: [],
            activityList: [],
            activityUuid:"",
        };
    },
    created() {
        this.getActivityList();
    },
    methods: {
        getActivityList() {
            activitiesList({activityType: "CENTRAL"}).then((res) => {
                if (res.success) {
                    this.activityList = res.data;
                    if(this.$route.params.data){
                        this.form.activityUuid = this.$route.params.data.uuid;
                    }
                    this.getOrderShopList();
                }
            });
        },
        getOrderShopList() {
            let params = {
                orderType: "CENTRAL",
                current: this.current,
                pageSize: this.pageSize,
                goodsName: this.goodsName,
                orderNo: this.orderNo,
                storeName: this.storeName,
                startDate: this.startTime,
                endDate: this.endTime,
                orderStatus: this.orderStatus == "ALL" ? "" : this.orderStatus,
                activityUuid: this.activityUuid,
            };
            getOrderShopList(params).then((res) => {
                this.total = res.total;
                this.printMessage = res.list;
            });},
        // 分页
        handleCurrentChange(val) {
            this.current = val;
            this.getOrderShopList();
        },
        goToDetail(orderBaseUuid) {
            this.$router.push({
                name:'collectOrderDetails',
                query:{orderBaseUuid:orderBaseUuid}
            })
        },
        searchInfo() {
            this.current = 1;
            this.getOrderShopList();
        },
        resetData(){
            this.activityUuid = "";
            this.createDateValue = null;
            this.goodsName = '';
            this.storeName = '';
            this.buyerName = '';
            this.orderNo = '';
            this.startTime = "";
            this.endTime = "";
            this.getOrderShopList()
        },
        // 时间格式
        chooseDate(){
            this.startTime = "";
            this.endTime = "";
            // 判断时间
            if(this.createDateValue!=null && this.createDateValue.length==2){
                this.startTime = this.timeDate(this.createDateValue[0]);
                this.endTime = this.timeDate(this.createDateValue[1]);
            }
        },
        timeDate(value){
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? "0" + MM : MM;
            let d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + MM + "-" + d;
        },
    },
};
</script>

<style scoped lang="less">
.collectOrderManagement {
    background: #fff;
    min-height: 1011px;
    padding: 20px 20px 20px;
    margin-left: 20px;
    .orderListTabs {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
        margin-left: 20px;
    }

    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7;
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #e4e7ed;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }

    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }

    /deep/ .el-tabs__item.is-active {
        color: #3686d7;
    }

    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }

    .orderSearchBox {
        .timeSearch {
            background-color: #f2f4f7;
            height: 35px;
            display: flex;
            align-items: center;
            margin-bottom: 22px;
            margin-right: 30px;
            border-radius: 8px;

            span {
                font-size: 12px;
                color: #c0c4cc !important;
                font-weight: normal;
                padding-left: 15px;
                margin-right: 5px;
            }

            // /deep/ .el-range-input{
            //         background-color: #f2f4f7;
            //             &:hover, &:focus {
            //             background-color: #fff;
            //             // border: 1px solid #108EE9;
            //         }
            // }
            /deep/ input::-webkit-input-placeholder {
                color: #c0c4cc;
                font-size: 12px;
            }

            /deep/ .el-range-input:hover {
                background-color: #fff !important;
            }

            /deep/ .el-date-editor .el-range-separator {
                line-height: 25px;
                color: #c0c4cc;
            }

            /deep/ .el-date-editor .el-range__close-icon {
                line-height: 28px;
            }

            /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
                background-color: white;
            }

            /deep/ .el-input__inner {
                width: 225px;
                height: 35px;
                min-height: 35px;
                font-size: 12px;
                color: #999999;
                background-color: #f2f4f7;
                border: 1px solid #f2f4f7;
                border-radius: 5px;

                .el-range-input {
                    background-color: #f2f4f7;
                }

                &:hover, &:focus {
                    background-color: #fff;
                    border: 1px solid #108EE9;

                }
            }
        }
        display: flex;
        flex-wrap: wrap;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .orderListTable {
        .orderNomesaage {
            color: #888;
            text-align: center;
            padding: 15px 0;
        }

        .tableHeader {
            display: flex;
            width: 100%;
            height: 35px;
            line-height: 35px;
            background: #f3f7ff;
            border-radius: 5px;
            margin: 0 0 15px;

            li {
                text-align: center;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.85);
            }
        }

        .tableBody {
            li {
                width: 100%;
                border: 1px solid #f2f2f2;
                border-radius: 10px;
                margin-bottom: 16px;

                .itemTop {
                    width: 100%;
                    height: 42px;
                    background: #ebf3fb;
                    line-height: 42px;
                    font-size: 14px;
                    color: #333;
                    padding: 0 20px;
                    display: flex;
                    align-items: center;
                    position: relative;

                    div {
                        margin-right: 30px;
                    }

                    .merchantInfo {
                        display: flex;
                        align-items: center;

                        i {
                            color: #3d7fff;
                            font-size: 25px;
                            cursor: pointer;
                            padding-left: 5px;
                            display: block;
                        }

                        img {
                            display: block;
                            padding-right: 5px;
                        }
                    }

                    .complainBtn {
                        color: #999;
                        position: absolute;
                        right: 20px;
                    }
                }

                .itemBottom {
                    display: flex;
                    align-items: center;
                    color: #333;
                    font-size: 13px;

                    .orderInfo {
                        padding: 20px;
                        display: flex;

                        img {
                            display: block;
                            width: 100px;
                            height: 100px;
                            border-radius: 10px;
                            margin-right: 30px;
                        }

                        .infoContent {
                            .infoName {
                                font-size: 14px;
                                color: #000000;
                                padding-bottom: 10px;
                            }

                            .infoOther {
                                font-size: 13px;
                                color: #999999;
                                padding-bottom: 8px;
                            }
                        }
                    }

                    .arguments {
                        padding: 20px;
                    }

                    .argumentsName {
                        padding-bottom: 8px;
                    }

                    .payment {
                        h3 {
                            font-size: 14px;
                            font-weight: 700;
                            margin: 0;
                        }

                        .title {
                            font-size: 12px;
                            color: #999999;
                        }
                    }

                    .status {
                        font-size: 14px;
                    }

                    .operationBtn {
                        display: block;
                        color: #0c75d3;
                        text-align: center;
                        width: 100%;
                        margin: 0;
                    }

                    .operationBtnMoney {
                        color: #0c75d3;
                        padding: 6px 20px;
                        border: 1px solid #0c75d3;
                        border-radius: 6px;
                        margin-left: 10px;
                        margin-top: 12px;

                        &:nth-last-of-type(1) {
                            margin-bottom: 12px;
                        }
                    }
                }
            }
        }

        .name {
            flex: 1;
        }
        .activeName {
            width: 110px;
            text-align: center;
        }

        .price {
            width: 246px;
            text-align: center;
        }

        .num {
            width: 95px;
            text-align: center;
        }

        .arguments {
            width: 294px;
        }

        .payment {
            width: 242px;
            text-align: center;
        }

        .status {
            width: 200px;
            text-align: center;
        }

        .operation {
            width: 145px;
            text-align: center;
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/collectManage/collectOrderMage.vue